export default {
  breakpoint: 'breakpoint',
  resize: 'resize',
  showDialog: 'showDialog',
  closeDialog: 'closeDialog'
};
